import script from "./GreenifiedImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./GreenifiedImage.vue?vue&type=script&lang=ts&setup=true"

import "./GreenifiedImage.vue?vue&type=style&index=0&id=7a2dbcd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2dbcd7"]])

export default __exports__